import {ErrorSeverities} from "@kta20-core/errors/custom-error";

export interface IUiServices {
    isLoading():boolean;
    displayModal(
            contentComponentName:string,
            /**
             * Data must map content component public properties
             */
            data?:any,
            onDidPresent?:(data?: any)=>void,
            onWillDismiss?:(data?: any)=>void,
            onDidDismiss?:(data?: any)=>void
     ):Promise<void>;

    dismissModal(data?:any):Promise<void>;

    /**
     *
     * @param {object} opts : see https://ionicframework.com/docs/api/action-sheet#properties
     * @param {function} onActionSheetDidDismiss
     * @param {function} onActionSheetDidPresent
     * @param {function} onActionSheetWillDismiss
     * @param {function} onActionSheetWillPresent
     */
    displayActionSheet(
        opts:any,
        onActionSheetDidDismiss?:(data?:any)=>void,
        onActionSheetDidPresent?:(data?:any)=>void,
        onActionSheetWillDismiss?:(data?:any)=>void,
        onActionSheetWillPresent?:(data?:any)=>void
    ):Promise<void>;

    dismissActionSheet(data?:any):Promise<void>;

    displayToast(options: IToastOptions): Promise<any>;
    displaySessionExpireToast(): Promise<any>;
    displayToastError(message: string, duration?:number, severity?: ErrorSeverities);

    dismissLoading():Promise<void>;
    displayLoading(
        message:string,
        showBackdrop?:boolean,
        spinner?:string,
        translucent?:boolean,
        animated?:boolean,
        backdropDismiss?:boolean,
        cssClass?:string,
        duration?:number,
        enterAnimation?:any,
        keyboardClose?:boolean,
        leaveAnimation?:any
    ): Promise<void>;

    displayAlert(alertOptions:any):Promise<void>;
}

export interface IToastOptions {
    header?: string;
    message?: string;
    cssClass?: string | string[];
    duration?: number;
    buttons?: (Object | string)[];
    showCloseButton?: boolean;
    closeButtonText?: string;
    position?: string;
    translucent?: boolean;
    animated?: boolean;
    color?: string;
    mode?: string;
    keyboardClose?: boolean;
    id?: string;
    enterAnimation?: Object;
    leaveAnimation?: Object;
}

export const ErrorColorMap = {
    [ErrorSeverities.RECOVERABLE]: "orange",
    [ErrorSeverities.UNRECOVERABLE]: "red"
};
